export default __webpack_public_path__ + "src/components/pages/login/customers/8f27d075cac5df41b9a83118bf8a4128.png";